import React, { useContext, useEffect, useState } from "react";
import $ from "jquery";
import axios from "axios";
import { BASE_URL } from "../../utils/Constants";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "./Users.css"
import AuthContext from "../../store/auth-context";
const Users = () => {
  const [allUsers, setAllUsers] = useState([]);
  let navigate = useNavigate();
  const AuthCtx = useContext(AuthContext)
  useEffect(() => {

    Swal.showLoading();
    axios.get(`${BASE_URL}/users/getusers.php`).then((res: any) => {

      $('#dataTable').DataTable().destroy();
      setAllUsers(res.data.data)

      Swal.close();
    }).catch((err: any) => {
      AuthCtx.Logout()
    })

  }, [])

  useEffect(() => {
    $('#dataTable').DataTable();
  }, [allUsers]);

  const handleUser = (id = 0) => {
    navigate(`/usercontent?id=${id}`)
  }
  return (
    <>
      <button className="btn  mb-3" style={{ backgroundColor: "#51469c" }} onClick={() => { handleUser(); }}> Add user </button>
      <div className="table-responsive">
        <table id="dataTable" className="table table-bordered">
          <thead>
            <tr>
              <th scope="col">id</th>
              <th scope="col">Name </th>
              <th scope="col"  style={{
                fontSize: "12px", color: "black", backgroundColor: "#eeeeee", textAlign: "center", position: "sticky",
                left: 0, border: "1px solid black", zIndex: 50
              }}  >Email </th>
              <th scope="col">Password </th>
              <th scope="col">Role</th>
              <th scope="col">Actions</th>

            </tr>
          </thead>
          <tbody>
            {allUsers?.map((user: any) => {
              return (
                <tr>
                  <th scope="row">{user.id}</th>
                  <td >{user.displayname}</td>
                  <td   style={{
                      fontSize: "12px", color: "black", backgroundColor: "#eeeeee", textAlign: "center", position: "sticky",
                      left: 0, border: "1px solid black", zIndex: 50
                    }}>{user.email}</td>
                  <td>{user.password}</td>
                  <td>{user.role}</td>
                  <td>

                    <button onClick={() => { navigate(`/assgingcourse?id=${user.id}`) }} className="btn btn-primary ">Edit user courses </button>

                    <button onClick={() => { handleUser(user.id) }} className="btn " style={{ backgroundColor: "#63c29d" }}>Edit  </button>


                  </td>

                </tr>

              )
            })}

          </tbody>
        </table>
      </div>
    </>
  )
}


export default Users